import { connect, Dispatch } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';
import { searchDriveItems } from '../../DriveItemList/Search/actions';
import { SearchDriveItemState } from '../../DriveItemList/Search/reducer';

interface SearchDriveItemListPageProps extends AbstractDriveItemListPageProps {
	dispatch: Dispatch<StoreState>;
	search: SearchDriveItemState;
}

export class SearchDriveItemListPage extends AbstractDriveItemListPage<SearchDriveItemListPageProps> {

	headerLabel = 'messages.search_results';
	noItemsLabel = 'messages.no_results';

	initializeView(props: SearchDriveItemListPageProps): void {
		const { dispatch, params: { originParam }, search } = props;
		const { isFetching } = search;

		if (!isFetching) {
			dispatch(searchDriveItems(originParam || ''));
		}
	}

	getDriveItemIds(): number[] {
		const { isFetching, driveItemIds} = this.props.search;
		return isFetching ? [] : driveItemIds;
	}

	isFetching(driveItemIds: number[]): boolean {
		return this.props.search.isFetching;
	}

	renderAdditionalItems(): JSX.Element[] | null {
		return null;
	}

	getAdditionalItemsLength(): number {
		return 0;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { search } = state;
	return { search };
};

export default connect(mapStateToProps)(SearchDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Search.tsx